import { Routes } from '@angular/router';
import { AuthService } from 'providers/auth.service';
import { screenshotRequiredPermissions } from 'shared/dialogs/screenshot-dialog/screenshot-dialog.component';

export const dialogRoutes: Routes = [
    {
        path: 'connector',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.read'],
        },
        loadChildren: () =>
            import('./shared/dialogs/connector-dialog/connector-dialog.module').then((m) => m.ConnectorDialogModule),
    },
    {
        path: 'satellite',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.read'],
        },
        loadChildren: () =>
            import('./shared/dialogs/satellite-dialog/satellite-dialog.module').then((m) => m.SatelliteDialogModule),
    },
    {
        path: 'tx',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['chargingSessions.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/transaction-dialog/transaction-dialog.module').then(
                (m) => m.TransactionDialogModule
            ),
    },
    {
        path: 'power-graph',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['chargingSessions.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/power-graph-dialog/power-graph-dialog.module').then(
                (m) => m.PowerGraphDialogModule
            ),
    },
    {
        path: 'notes',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.ticketing.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/tickets-list-dialog/ticket-list-dialog.module').then(
                (m) => m.TicketListDialogModule
            ),
    },
    {
        path: 'settings-profile',
        canActivate: [AuthService],
        data: {
            requiredPermissions: [
                'fleet.chargingStation.settings.access',
                'fleet.chargingStation.settings.actions.manageSharedSettingsProfile',
            ],
        },
        loadChildren: () =>
            import('./shared/dialogs/settings-profiles-dialog/settings-profile-dialog.module').then(
                (m) => m.SettingsProfileDialogModule
            ),
    },
    {
        path: 'alert-history',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.read'],
        },
        loadChildren: () =>
            import('./shared/dialogs/alert-history-dialog/alert-history-dialog.module').then(
                (m) => m.AlertHistoryDialogModule
            ),
    },
    {
        path: 'settings-profile-status',
        canActivate: [AuthService],
        data: {
            requiredPermissions: [
                'fleet.chargingStation.settings.access',
                'fleet.chargingStation.settings.actions.manageSharedSettingsProfile',
            ],
        },
        loadChildren: () =>
            import('./shared/dialogs/settings-profiles-status-dialog/settings-profile-status-dialog.module').then(
                (m) => m.SettingsProfileStatusDialogModule
            ),
    },
    {
        path: 'ev',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['ev.allowTracking'],
        },
        loadChildren: () => import('./shared/dialogs/ev-dialog/ev-dialog.module').then((m) => m.EvDialogModule),
    },
    {
        path: 'order',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['salesOrders.access'],
        },
        loadChildren: () => import('./shared/orders/orders.module').then((m) => m.OrdersModule),
    },
    {
        path: 'txs',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['chargingSessions.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/session-list-dialog/session-list-dialog.module').then(
                (m) => m.SessionListDialogModule
            ),
    },
    {
        path: 'tokenList',
        canActivate: [AuthService],
        data: {
            requiredPermissions: [
                'fleet.chargingStation.settings.chargerAuthorization.access',
                'fleet.chargingStation.settings.chargerAuthorization.rfidManage',
            ],
        },
        loadChildren: () =>
            import('./shared/dialogs/token-list-dialog/token-list-dialog.module').then((m) => m.TokenListDialogModule),
    },
    {
        path: 'screenshot',
        canActivate: [AuthService],
        data: {
            requiredPermissions: screenshotRequiredPermissions,
            accessCondition: 'OR',
        },
        loadChildren: () =>
            import('./shared/dialogs/screenshot-dialog/screenshot-dialog.module').then((m) => m.ScreenshotDialogModule),
    },
    {
        path: 'virtualcharger',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
        },
        loadChildren: () =>
            import('./shared/dialogs/virtual-charger-dialog/virtual-charger-dialog.module').then(
                (m) => m.VirtualChargerDialogModule
            ),
    },
    {
        path: 'cabinet',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.hardware.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/cabinet-dialog/cabinet-dialog.module').then((m) => m.CabinetDialogModule),
    },
    {
        path: 'firmware',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.firmware.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/firmware-dialog/firmware-dialog.module').then((m) => m.FirmwareDialogModule),
    },
    {
        path: 'firmwareList',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.firmware.applyUpdate.allVersions'],
        },
        loadChildren: () =>
            import('./shared/dialogs/firmware-list-dialog/firmware-list-dialog.module').then(
                (m) => m.FirmwareListDialogModule
            ),
    },
    {
        path: 'firmwareUpdateStatus',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.firmware.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/firmware-update-status-dialog/firmware-update-status-dialog.module').then(
                (m) => m.FirmwareUpdateStatusDialogModule
            ),
    },
    {
        path: 'timeline',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.overview.showTimeline'],
        },
        loadChildren: () =>
            import('./shared/dialogs/timeline-vertical-dialog/timeline-vertical-dialog.module').then(
                (m) => m.TimelineVerticalDialogModule
            ),
    },
    {
        path: 'connectivity',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.connectivity.setup'],
        },
        loadChildren: () =>
            import('./shared/dialogs/connectivity-dialog/connectivity-dialog.module').then(
                (m) => m.ConnectivityDialogModule
            ),
    },
    {
        path: 'charger',
        canActivate: [AuthService],
        data: {
            requiredPermissions: [
                'fleet.chargingStation.hardware.showTechnicalInfo',
                'fleet.chargingStation.connectivity.setup',
            ],
            accessCondition: 'OR',
        },
        loadChildren: () =>
            import('./shared/dialogs/charger-dialog/charger-dialog.module').then((m) => m.ChargerDialogModule),
    },
    {
        path: 'fetch-logs',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.systemLog.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/fetch-system-logs-dialog/fetch-system-logs-dialog.module').then(
                (m) => m.FetchSystemLogsDialogModule
            ),
    },
    {
        path: 'tx-state-log',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.txStateLog.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/tx-state-log-dialog/tx-state-log-dialog.module').then(
                (m) => m.TxStateLogDialogModule
            ),
    },
    {
        path: 'scan-inventory',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.connectivity.setup'],
        },
        loadChildren: () =>
            import('./shared/dialogs/scan-station-inventory-dialog/scan-station-inventory-dialog.module').then(
                (m) => m.ScanStationInventoryDialogModule
            ),
    },
    {
        path: 'execute-matrix-test',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.connectivity.setup'],
        },
        loadChildren: () =>
            import(
                './locations/station-dialog/configuration/matrix-test/execute-matrix-test-dialog/execute-matrix-test-dialog.module'
            ).then((m) => m.ExecuteMatrixTestDialogModule),
    },
    {
        path: 'alert',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.read'],
        },
        loadChildren: () =>
            import('./shared/dialogs/alert-dialog/alert-dialog.module').then((m) => m.AlertDialogModule),
    },
    {
        path: 'external-notifications',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
        },
        loadChildren: () =>
            import('./shared/dialogs/external-notifications-log-dialog/external-notifications-log-dialog.module').then(
                (m) => m.ExternalNotificationsLogDialogModule
            ),
    },
    {
        path: 'share-charger-data',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
        },
        loadChildren: () =>
            import('./shared/dialogs/share-charger-data-dialog/share-charger-data-dialog.module').then(
                (m) => m.ShareChargerDataDialogModule
            ),
    },
    {
        path: 'audit-log',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.auditLog.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/audit-log-dialog/audit-log-dialog.module').then((m) => m.AuditLogDialogModule),
    },
    {
        path: 'emeter-sessions',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['chargingSessions.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/emeter-sessions-dialog/emeter-sessions-dialog.module').then(
                (m) => m.EmeterSessionsDialogModule
            ),
    },
    {
        path: 'check-adaptive-voltage-compatibility',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.hardware.troubleshootingTools.inventoryScan'],
        },
        loadChildren: () =>
            import(
                './shared/dialogs/check-adaptive-voltage-compatibility-dialog/check-adaptive-voltage-compatibility-dialog.module'
            ).then((m) => m.CheckAdaptiveVoltageCompatibilityDialogModule),
    },
    {
        path: 'warranty',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.read'],
        },
        loadChildren: () =>
            import('./shared/dialogs/warranty-dialog/warranty-dialog.module').then((m) => m.WarrantyDialogModule),
    },
    {
        path: 'liquid-cooling-system-status',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.read'],
        },
        loadChildren: () =>
            import(
                './shared/dialogs/liquid-cooling-system-status-dialog/liquid-cooling-system-status-dialog.module'
            ).then((m) => m.LiquidCoolingSystemStatusModule),
    },
    {
        path: 'metric-chart',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.read'],
        },
        loadChildren: () =>
            import('./shared/dialogs/metric-values-chart-dialog/metric-values-chart-dialog.module').then(
                (m) => m.MetricValuesChartDialogModule
            ),
    },
    {
        path: 'asset',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['assets.access'],
        },
        loadChildren: () =>
            import('./shared/dialogs/asset-dialog/asset-dialog.module').then((m) => m.AssetDialogModule),
    },
    {
        path: 'charger-lobby',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.read'],
        },
        loadChildren: () =>
            import('./shared/charger-lobby/charger-lobby-dialog/charger-lobby-dialog.module').then(
                (m) => m.ChargerLobbyDialogModule
            ),
    },
    {
        path: 'audit-logs',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
        },
        loadChildren: () =>
            import('./shared/dialogs/audit-logs-dialog/audit-logs-dialog.module').then((m) => m.AuditLogsDialogModule),
    },
    {
        path: 'share-location',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
        },
        loadChildren: () =>
            import('./shared/dialogs/share-location-dialog/share-location-dialog.module').then(
                (m) => m.ShareLocationDialogModule
            ),
    },
    {
        path: 'ssh-status',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
        },
        loadChildren: () =>
            import('./shared/dialogs/ssh-status-dialog/ssh-status-dialog.module').then((m) => m.SshStatusDialogModule),
    },
];
